"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.exportRequestsFactory = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const evidence_1 = require("../../../composite/evidence/evidence");
const AuthoredEvidence = __importStar(require("../../../composite/evidence-2/authored-evidence/authored-evidence"));
const export_requests_colums_1 = require("./export-requests-colums");
const export_requests_fields_1 = require("./export-requests-fields");
const export_context_1 = require("../export-context");
function exportRequestsFactory({ exportTag }) {
    return function ExportRequests() {
        const intl = react_intl_1.useIntl();
        const columns = export_requests_colums_1.useColumns();
        const { url } = react_1.useContext(export_context_1.ExportContext);
        const evidence = AuthoredEvidence.useAuthoredEvidence({
            identifier: 'EXPORT_REQUESTS',
            apiProps: {
                url: `${url}/requests`,
            },
            tableProps: {
                columns,
                tableName: intl.formatMessage({
                    id: 'EAS_EXPORT_REQUESTS_TABLE_TITLE',
                    defaultMessage: 'Fronta exportu',
                }),
                reportTag: exportTag,
            },
            detailProps: {
                FieldsComponent: export_requests_fields_1.ExportRequestsFields,
                toolbarProps: {
                    title: intl.formatMessage({
                        id: 'ES__EXPORT_REQUESTS__DETAIL__TITLE',
                        defaultMessage: 'Fronta exportu',
                    }),
                    showBtn: () => false,
                },
            },
        });
        return react_1.default.createElement(evidence_1.Evidence, Object.assign({}, evidence));
    };
}
exports.exportRequestsFactory = exportRequestsFactory;
exportRequestsFactory.useColumns = export_requests_colums_1.useColumns;
exportRequestsFactory.Fields = export_requests_fields_1.ExportRequestsFields;
//# sourceMappingURL=export-requests.js.map